import { create } from "zustand";
import Cookies from "js-cookie";
import { TOKEN_COOKIE_CONFIG } from "../../config";

const RAWDATA_KEY = "rawData";

const useAuth = create((set, get) => ({
  userID: Cookies.get("userID"),
  userRole: Cookies.get("userRole"),
  accessToken: Cookies.get("accessToken"),
  refreshToken: Cookies.get("refreshToken"),
  isAuthenticated: !!Cookies.get("accessToken"),
  currentUser: (() => {
    const data = localStorage.getItem(RAWDATA_KEY);
    return data ? JSON.parse(data) : null;
  })(),
  setTokens: (accessToken, refreshToken, userID, userRole, rawData = {}) => {
    Cookies.set("accessToken", accessToken, TOKEN_COOKIE_CONFIG);
    Cookies.set("refreshToken", refreshToken, TOKEN_COOKIE_CONFIG);
    Cookies.set("userID", userID, TOKEN_COOKIE_CONFIG);
    Cookies.set("userRole", userRole, TOKEN_COOKIE_CONFIG);
    // Save large data in localStorage, not cookies
    localStorage.setItem(RAWDATA_KEY, JSON.stringify(rawData));
    set({
      accessToken,
      refreshToken,
      isAuthenticated: true,
      userID,
      userRole,
      currentUser: rawData,
    });
  },
  getRole: () => Cookies.get("userRole"),
  getRawData: () => get().currentUser,
  clearTokens: () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("userID");
    Cookies.remove("userRole");
    localStorage.removeItem(RAWDATA_KEY);
    set({
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      userID: null,
      userRole: null,
      currentUser: null,
    });
  },
  updateAccessToken: (newAccessToken) => {
    Cookies.set("accessToken", newAccessToken, TOKEN_COOKIE_CONFIG);
    set({ accessToken: newAccessToken });
  },
}));

export default useAuth;